const config = {
  ApiGateway: 
  {
   Endpoint: process.env.REACT_APP_NADHEO_ENDPOINT
  },
  Cognito:
  {
    Region: "eu-west-1",
    UserPoolId: "eu-west-1_aSigjVkoc",
    AppClientId: "2kd5bghdddt64j83s5f02h8h6j",
    IdentityPoolId: "eu-west-1:a7dc674f-c605-44c7-a4c4-5d05f2ea5485",
    Domain: "nadheo3.auth.eu-west-1.amazoncognito.com",
    RedirectSignIn: "https://tautisband.nadheo.eu",
    RedirectSignOut: "https://tautisband.nadheo.eu",
    OauthResponseType: "code",
    PwdFreeUserPoolId: "eu-west-1_k0qrUCrpz",
    PwdFreeAppClientId: "1uimaans4p9hn79ug7ks7s2mqj"
  },
  Locize:
  {
    ProjectNamespace: "tautis-14.03.2026"
  }
};

export default config;
